import clsx from "clsx";
import { textBodyStyle } from "..";

export default function HTMLTextArea({ onHTML, htmlText }) {
  return (
    <textarea
      className={textBodyStyle + textAreaStyle}
      value={htmlText}
      onChange={onHTML}
    />
  );
}

const textAreaStyle = clsx(
  " border-b-[1px] border-x-[1px] rounded-b-md border-black/10 p-4"
);
